import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgetPasswordComponent } from 'src/app/modules/users/components/forget-password/forget-password.component';
import { LoginComponent } from 'src/app/modules/users/components/login/login.component';
import { WelcomeComponent } from 'src/app/modules/users/components/welcome/welcome.component';
import { ModuleSelectionComponent } from 'src/app/modules/users/components/module-selection/module-selection.component';
import { LoginCallbackComponent } from 'src/app/modules/users/components/login-callback/login-callback.component';
import { LoginActivate } from '../../sharedFeatures/services/login-activate.service';
import { AuthGuard } from '../../sharedFeatures/services/auth-guard.service';
import { ActiveSessionsComponent } from 'src/app/modules/users/components/active-sessions/active-sessions.component';
import { SecuritySettingsComponent } from 'src/app/modules/users/components/security-settings/security-settings.component';

const routes: Routes = [
  // Public landing pages (default entry point) - Qualidad marketing site
  {
    path: '',
    loadChildren: () =>
      import('src/app/modules/qualidad/qualidad.module').then(
        m => m.QualidadModule
      ),
  },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'login', component: LoginComponent, canActivate: [LoginActivate] },
  { path: 'login-callback', component: LoginCallbackComponent },
  {
    path: 'modules',
    component: ModuleSelectionComponent,
    canActivate: [AuthGuard],
  },
  // Security & Session Management (VAPT Issue #3 - Iteration 2)
  {
    path: 'active-sessions',
    component: ActiveSessionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'security-settings',
    component: SecuritySettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'users',
    loadChildren: () =>
      import('src/app/modules/users/users.module').then(m => m.UsersModule),
  },

  // {
  //   path: 'projectTaskStatus',
  //   loadChildren: () =>
  //     import('src/app/modules/projectTaskStatus/projectTaskStatus.module').then(
  //       m => m.ProjectTaskStatusModule
  //     ),
  // },
  {
    path: 'section',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/section/section.module').then(
        m => m.SectionModule
      ),
  },
  {
    path: 'project',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/project/project.module').then(
        m => m.ProjectModule
      ),
  },
  {
    path: 'project-cr',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/project-cr/project-cr.module').then(
        m => m.ProjectCrModule
      ),
  },
  {
    path: 'milestone',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/mileStone/mileStone.module').then(
        m => m.MileStoneModule
      ),
  },
  {
    path: 'tags',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/tag/tag.module').then(m => m.TagModule),
  },
  {
    path: 'user-role',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/user-role/user-role.module').then(
        m => m.UserRoleModule
      ),
  },

  // {
  //   path: 'projectTask',
  //   loadChildren: () =>
  //     import('src/app/modules/projectTask/projectTask.module').then(
  //       m => m.ProjectTaskModule
  //     ),
  // },
  {
    path: 'roles',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/roles/roles.module').then(m => m.RolesModule),
  },
  {
    path: 'tasks',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/tasks/tasks.module').then(m => m.TasksModule),
  },
  {
    path: 'section-chart',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/chart/section-chart.module').then(
        m => m.SectionChartModule
      ),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/reporting/reporting.module').then(
        m => m.ReportingModule
      ),
  },

  {
    path: 'project-head',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/project-head/project-head.module').then(
        m => m.ProjectHeadModule
      ),
  },
  //#region user management
  {
    path: 'system-code',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/system-code/system-code.module').then(
        m => m.SystemCodeModule
      ),
  },

  {
    path: 'user-management',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/user-management/user-management.module').then(
        m => m.UserManagementModule
      ),
  },

  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/dashboard/dashboard.module').then(
        m => m.DashboardModule
      ),
  },
  //#endregion

  //#region MSM CheckList
  {
    path: 'msm-checklist',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        'src/app/modules/MSM_CheckListFront/msm-checklist-front.module'
      ).then(m => m.MSMChecklistFrontModule),
  },
  {
    path: 'project-head-ui',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        'src/app/modules/MSM_CheckListFront/ProjectHeadUI/project-head-ui.module'
      ).then(m => m.ProjectHeadUiModule),
  },
  {
    path: 'general-dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        'src/app/modules/MSM_CheckListFront/generaldashboard/general-dashboard.module'
      ).then(m => m.GeneralDashboardModule),
  },
  //#endregion

  // Catch-all: redirect any unknown route to login
  {
    // Chat at /ai-assistant, provider administration at /ai-assistant/admin.
    // Both API surfaces enforce their own privilege checks, so the guard here is for
    // navigation only and is not what protects the data.
    path: 'ai-assistant',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/ai-assistant/ai-assistant.module').then(
        m => m.AiAssistantModule
      ),
  },
  { path: '**', redirectTo: 'login' },
  //{ path: '**', redirectTo: 'system-code/list' }, // Catch-all route
  // { path: 'system**', redirectTo: 'system-code/list' }, // Catch-all route { path: 'system', redirectTo: 'system-code/list', pathMatch: 'full' },
  //  { path: 'system/:subPath', redirectTo: 'system-code/list' },
  //  { path: 'system-code/:subPath', redirectTo: 'system-code/list' },

  //  { path: '', redirectTo: 'msm-checklist/mystery-shopper', pathMatch: 'full' },
  //  { path: '**', redirectTo: 'msm-checklist/mystery-shopper' }, // Catch-all route for MSM users
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
